import { useState, useEffect } from 'react'
import './dashboard-button-group.scss';
import { FluentTooltip } from '../../../../components/FluentUI/Fluent-Tooltip';
import { FluentButton } from '../../../../components/FluentUI/Fluent-Button';
import FluentUiIcon from '../../../../assets/fluent-ui-icon';
import PropTypes from "prop-types";

const DashboardButtonGroup = ({ fetchDepartmentData, refreshLoading }) => {
    const [refreshTime, setRefreshTime] = useState();

    const getTimeDay = () => {
        let today = new Date();
        let hour = today.getHours();
        let minute = today.getMinutes();
        let second = today.getSeconds();

        if (hour > 12) { hour = hour - 12;}
        if (hour === 0) { hour = 12;}
        if (minute < 10) { minute = "0" + minute;}
        if (second < 10) { second = "0" + second;}

        let date = (today.getMonth()+1)+'/'+today.getDate()+'/'+today.getFullYear();
        let time = hour + ":" + minute + ":" + second;
        let resTime = date+' at '+time;

        return resTime;
      }

    useEffect(() => {
        let fmtTime=getTimeDay();
        setRefreshTime(fmtTime);
    }, [])

    return (
        <div className="btn-dashboard-group">
            <FluentTooltip
                    positioning="below-end"
                    withArrow={true}
                    target={
                      <div>
                        <FluentButton
                          key="refresh"
                          icon={
                            <FluentUiIcon
                              name={"ArrowSyncRegular"}
                              size={24}
                              color="#242424"
                            />
                          }
                          onClick={() => {
                            let fmtTime = getTimeDay();
                            setRefreshTime(fmtTime);
                            fetchDepartmentData();
                            refreshLoading(true);
                          }}
                          className="bg-white"
                        />
                      </div>
                    }
                    text={`Last updated: ${refreshTime}`}
                  />
        </div>
    )
}

export default DashboardButtonGroup;

DashboardButtonGroup.propTypes = {
  fetchDepartmentData: PropTypes.func,
  refreshLoading: PropTypes.func
}
